exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".NumInputVcDemo .demoItem[data-v-945edcd6]{margin-right:15px}.NumInputVcDemo .demoItem .demoLabel[data-v-945edcd6]{margin-right:10px}.NumInputVcDemo p[data-v-945edcd6]{color:#066}.NumInputVcDemo .demoText[data-v-945edcd6]{margin:15px 10px 5px}", ""]);

// exports
